function passwordToggle(inputFieldId: string, toggleButtonId: string) {
    const inputField = document.querySelector(`#${inputFieldId}`);
    const toggleButton = document.querySelector(`#${toggleButtonId}`);

    if (!(inputField instanceof HTMLInputElement) || !(toggleButton instanceof HTMLButtonElement)) {
        console.error('Buckeye UX Text Field: Missing either the input field or toggle button.');
        return;
    }

    inputField.type = inputField.type === "password" ? "text" : "password";
    toggleButton.classList.toggle("bux-text-field__password-icon--hide");
    toggleButton.title = toggleButton.title === "Hide Password" ? "Show Password" : "Hide Password";
    toggleButton.ariaPressed = toggleButton.title === "Hide Password" ? "true" : "false";
}

const passwordToggleButtons = document.querySelectorAll(".bux-text-field__password-icon");
for (const toggleButton of passwordToggleButtons) {
    const randomId = toggleButton.id.split("-")[4];
    const inputFieldId = `bux-text-field__text-field-${randomId}`;
    toggleButton.addEventListener("click", () => passwordToggle(inputFieldId, toggleButton.id));
}
